import { Component, OnInit, ViewChild } from '@angular/core';
import { FrequentlyAskedQuestionsComponent } from '../frequently-asked-questions/frequently-asked-questions.component';
import { BlogComponent } from "../blog/blog.component";
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscribeComponent } from '../../shared/components/subscribe/subscribe.component';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SubscribeComponent,FrequentlyAskedQuestionsComponent, BlogComponent,RouterModule,CommonModule,FormsModule, ReactiveFormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  constructor
  (){}

  ngOnInit(): void {

  }
}
